import { shouldClientReconnect } from '../../../network/should-client-reconnect.ts';
import { WebSocketCodes } from '../../../network/websocket-codes.ts';
import { type SocketMachineContext } from '../../network-state-machine-context.ts';
import { type CloseEvent } from '../../network-state-machine-events.ts';

export function isSessionRevoked(_: SocketMachineContext, event: CloseEvent) {
  return event.code === WebSocketCodes.SESSION_REVOKED;
}

export function isPossibleToRetry(_: SocketMachineContext, event: CloseEvent) {
  return shouldClientReconnect(event.code);
}

export function resetDebounce(context: SocketMachineContext) {
  context.debounce.resetAttempts();
  return context;
}
